export const convertUrlString = (inputString: string): string => {
    const parts = inputString.split("/").filter((part) => part !== "");
    if (parts.length === 1) {
      return "";
    }
    parts.shift();
    const resultString = "/" + parts.join("/");
    return resultString;
  };